import React from 'react';

// Try to import PuffLoader, fallback to null if not available
let PuffLoader = null;
try {
  PuffLoader = require('react-spinners').PuffLoader;
} catch (error) {
  console.log('react-spinners not available, using CSS fallback');
}

const SmartLoadingSpinner = ({ 
  loading = false, 
  size = 60, 
  color = "#3B82F6", 
  overlay = true,
  blur = true 
}) => {
  if (!loading) return null;

  const sizeClass = size > 80 ? 'w-20 h-20' : size > 60 ? 'w-16 h-16' : size > 40 ? 'w-12 h-12' : 'w-10 h-10';

  return (
    <>
      <div className={`
        fixed inset-0 z-50 flex items-center justify-center
        ${overlay ? 'bg-black bg-opacity-30' : ''}
        ${blur ? 'backdrop-blur-sm' : ''}
        transition-all duration-300 ease-in-out
      `}>
        {/* Simple Loading Text Only */}
        <div className="text-center">
          <p className="text-white font-medium text-xl animate-pulse drop-shadow-lg">
            Loading...
          </p>
        </div>
      </div>

      {/* Custom CSS Animations for fallback */}
      <style jsx>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.2;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.05);
          }
        }
        
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }
      `}</style>
    </>
  );
};

export default SmartLoadingSpinner;
